<template>
  <div style="position: relative; z-index: 999999999999999999999999;display: inline-block;top: -12px;">
    <!-- 按钮 -->
    <button class="ai-assistant-btn" @click="toggleAIDialog()">
      <svg class="ai-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
      AI智能客服助手
    </button>

    <!-- 对话框 -->
    <div class="ai-dialog-container" v-show="isDialogOpen" id="aiDialog">
      <iframe v-if="(token && isDialogOpen) || isInit" ref="iframe" :src="envUrl + '/ai/#/?token=' + token + '&aiType=1'"
        style="width: 666px;height: 700px;position: relative;z-index: 999999999;" frameborder="0"></iframe>

      <div v-if="iLoading" element-loading-text="AI智能客服助手加载中" v-loading="iLoading"
        style="width: 100%;height: 100%;position: absolute;z-index: 999999999;top: 0;">

      </div>

      <div>
        <i @click="isDialogOpen=false" class="el-icon-circle-close" style="position: absolute;top: 20px;right: 26px;color: white;font-size: 22px;z-index: 999999999;cursor: pointer;"></i>
      </div>
    </div>

  </div>

</template>
<script>
export default {
  name: 'AiButton',
  data() {
    return {
      envUrl: 'http://jsyaqxx.cloudjoytech.com.cn:9081',
      // envUrl: 'http://146.56.243.148:50012',
      isDialogOpen: false,
      token: "",
      iLoading: false,
      isInit: false,
    };
  },
  mounted() {
  },
  created() {
    this.token = sessionStorage.getItem('token');
  },
  watch: {
    // 监听 token 的变化
    isDialogOpen(newVal) {
      if (newVal) {
        if (!this.isInit) {
          this.iLoading = true;
        }
      }
    },
  },

  // vue生命周期钩子函数 -- 更新之后
  updated() {
    if (this.$refs.iframe) {
      // IE
      if (this.$refs.iframe.attachEvent) {
        this.$refs.iframe.attachEvent('onload', () => {
          // 加载成功
          this.iLoading = false;
          console.log('---------------s');
          this.isInit = true
        });
      } else {
        this.$refs.iframe.onload = () => {
          // 加载成功
          this.iLoading = false;
          console.log('---------------s1');
          this.isInit = true

        };
      }
    }
  },
  methods: {
    toggleAIDialog() {
      console.log(this.isDialogOpen);
      this.isDialogOpen = !this.isDialogOpen;
    },
  },

};

</script>


<!-- AI智能客服助手入口 -->
<style scoped>
.draggable-btn {
  position: absolute;
  cursor: move;
  /* 添加过渡效果提升体验 */
  transition: transform 0.1s ease;
  user-select: none;
  width: 240px;
  height: 50px;
}

/* 按钮样式 */
.ai-assistant-btn {
  position: relative;
  padding: 3px 12px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #4A90E2, #6C5B7B);
  color: white;
  font-family: 'Microsoft YaHei', sans-serif;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 8px 30px rgba(74, 144, 226, 0.4);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s;
  animation: pulse 2s infinite;
}

/* 动态流光边框 */
.ai-assistant-btn::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, #4A90E2, #8B48D3, #4A90E2);
  border-radius: 34px;
  z-index: -1;
  animation: borderFlow 3s linear infinite;
  opacity: 0.7;
}

/* 图标样式 */
.ai-icon {
  width: 24px;
  height: 24px;
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.5));
}

/* 对话框容器 */
.ai-dialog-container {
  position: fixed;
  bottom: 100px;
  right: 40px;
  width: 666px;
  height: 700px;
  backdrop-filter: blur(12px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

/* 动画定义 */
@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes borderFlow {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
